export const GIVE_RECOGNITION_MODAL_QUERY_PARAM = 'give_recognition';
export const GIVE_RECOGNITION_TEXT_QUERY_PARAM = 'give_recognition_text';
